import _classCallCheck from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import isPlainObject from 'is-plain-obj';
export var IS_PROXY = Symbol('IS_PROXY');
export var PATH = Symbol('PATH');
export var VALUE = Symbol('VALUE');
export var CACHED_PROXY = Symbol('CACHED_PROXY');
var arrayMutations = new Set(['push', 'shift', 'pop', 'unshift', 'splice', 'reverse', 'sort', 'copyWithin']);
export var Proxifier =
/*#__PURE__*/
function () {
  function Proxifier(tree) {
    var _this = this;

    _classCallCheck(this, Proxifier);

    this.tree = tree;
    this.proxyCache = {};

    this.removeProxies = function (path) {
      var pathArray = path.split('.');
      var currentCache = _this.proxyCache;
      var length = pathArray.length;
      var keyIndex = length - 1;

      for (var x = 0; x < length; x++) {
        var key = pathArray[x];

        if (!currentCache[key]) {
          return null;
        }

        if (x === keyIndex) {
          delete currentCache[key];
        } else {
          currentCache = currentCache[key];
        }
      }
    };

    this.disposeRemoveProxy = tree.master.onRemoveProxy(this.removeProxies);
  }

  _createClass(Proxifier, [{
    key: "concat",
    value: function concat(path, prop) {
      return path ? path + '.' + prop : prop;
    }
  }, {
    key: "addProxyToCache",
    value: function addProxyToCache(path, proxy) {
      var pathArray = path.split('.');
      var currentCache = this.proxyCache;
      var length = pathArray.length;
      var keyIndex = length - 1;

      for (var x = 0; x < length; x++) {
        var key = pathArray[x];

        if (!currentCache[key]) {
          currentCache[key] = {};
        }

        if (x === keyIndex) {
          currentCache[key][CACHED_PROXY] = proxy;
        } else {
          currentCache = currentCache[key];
        }
      }

      return proxy;
    }
  }, {
    key: "getProxyFromCache",
    value: function getProxyFromCache(path) {
      var pathArray = path.split('.');
      var currentCache = this.proxyCache;
      var length = pathArray.length;
      var keyIndex = length - 1;

      for (var x = 0; x < length; x++) {
        var key = pathArray[x];

        if (!currentCache[key]) {
          return null;
        }

        if (x === keyIndex) {
          return currentCache[key][CACHED_PROXY];
        } else {
          currentCache = currentCache[key];
        }
      }
    }
  }, {
    key: "ensureMutationTrackingIsEnabled",
    value: function ensureMutationTrackingIsEnabled(path) {
      if (this.tree.master.options.devmode && !this.tree.canMutate()) {
        throw new Error("proxy-state-tree - You are mutating the path \"".concat(path, "\", but it is not allowed"));
      }
    }
  }, {
    key: "isDefaultProxifier",
    value: function isDefaultProxifier() {
      return this.tree.proxifier === this.tree.master.proxifier;
    }
  }, {
    key: "ensureValueDosntExistInStateTreeElsewhere",
    value: function ensureValueDosntExistInStateTreeElsewhere(value) {
      if (value && value[IS_PROXY] === true) {
        throw new Error("proxy-state-tree - You are trying to insert a value that already exists in the state tree on path \"".concat(value[PATH], "\""));
      }
    }
  }, {
    key: "trackPath",
    value: function trackPath(path) {
      if (!this.tree.canTrack()) {
        return;
      }

      if (this.isDefaultProxifier()) {
        var trackStateTree = this.tree.master.currentTree;

        if (!trackStateTree) {
          return;
        }

        trackStateTree.addTrackingPath(path);
      } else {
        ;
        this.tree.addTrackingPath(path);
      }
    } // With tracking trees we want to ensure that we are always
    // on the currently tracked tree. This ensures when we access
    // a tracking proxy that is not part of the current tracking tree (pass as prop)
    // we move the ownership to the current tracker

  }, {
    key: "getTrackingTree",
    value: function getTrackingTree() {
      if (this.tree.master.currentTree && this.isDefaultProxifier()) {
        return this.tree.master.currentTree;
      }

      if (!this.tree.canTrack()) {
        return null;
      }

      if (this.tree.canTrack()) {
        return this.tree;
      }

      return null;
    }
  }, {
    key: "getMutationTree",
    value: function getMutationTree() {
      return this.tree.master.mutationTree || this.tree;
    }
  }, {
    key: "createArrayProxy",
    value: function createArrayProxy(value, path) {
      var proxifier = this;
      return this.getProxyFromCache(path) || this.addProxyToCache(path, new Proxy(value, {
        get: function get(target, prop) {
          if (prop === IS_PROXY) return true;
          if (prop === PATH) return path;
          if (prop === VALUE) return value;

          if (prop === 'length' || typeof target[prop] === 'function' && !arrayMutations.has(String(prop)) || typeof prop === 'symbol') {
            return target[prop];
          }

          var trackingTree = proxifier.getTrackingTree();
          var nestedPath = proxifier.concat(path, prop);
          trackingTree && trackingTree.proxifier.trackPath(nestedPath);
          var method = String(prop);

          if (arrayMutations.has(method)) {
            // On POP we can optimally remove cached proxy by removing the specific one
            // that was removed. If it is a PUSH, we do not have to remove anything, as
            // existing proxies stays the same
            if (method === 'pop') {
              proxifier.tree.master.removeProxy(nestedPath);
            } else if (method !== 'push') {
              proxifier.tree.master.removeProxy(path);
            }

            proxifier.ensureMutationTrackingIsEnabled(nestedPath);
            return function () {
              var mutationTree = proxifier.getMutationTree();

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              mutationTree.addMutation({
                method: method,
                path: path,
                args: args
              });
              return target[prop].apply(target, args);
            };
          }

          if (target[prop] === undefined) {
            return undefined;
          }

          return proxifier.proxify(target[prop], nestedPath);
        },
        set: function set(target, prop, value) {
          var nestedPath = proxifier.concat(path, prop);
          proxifier.ensureMutationTrackingIsEnabled(nestedPath);
          proxifier.ensureValueDosntExistInStateTreeElsewhere(value);
          var mutationTree = proxifier.getMutationTree();

          if (isPlainObject(target[prop])) {
            proxifier.tree.master.removeProxy(nestedPath);
          }

          mutationTree.addMutation({
            method: 'set',
            path: nestedPath,
            args: [value]
          });
          return Reflect.set(target, prop, value);
        }
      }));
    }
  }, {
    key: "createObjectProxy",
    value: function createObjectProxy(value, path) {
      var proxifier = this;
      return this.getProxyFromCache(path) || this.addProxyToCache(path, new Proxy(value, {
        get: function get(target, prop) {
          if (prop === IS_PROXY) return true;
          if (prop === PATH) return path;
          if (prop === VALUE) return value;
          if (typeof prop === 'symbol' || prop in Object.prototype) return target[prop];
          var descriptor = Object.getOwnPropertyDescriptor(target, prop);

          if (descriptor && 'get' in descriptor) {
            var _value = descriptor.get.call(proxifier.getProxyFromCache(path));

            if (proxifier.tree.master.options.devmode && proxifier.tree.master.options.onGetter) {
              proxifier.tree.master.options.onGetter(proxifier.concat(path, prop), _value);
            }

            return _value;
          }

          var trackingTree = proxifier.getTrackingTree();
          var targetValue = target[prop];
          var nestedPath = proxifier.concat(path, prop);
          trackingTree && trackingTree.proxifier.trackPath(nestedPath);

          if (typeof targetValue === 'function') {
            var dynamicValue = proxifier.tree.master.options.dynamicWrapper ? proxifier.tree.master.options.dynamicWrapper(proxifier.tree, nestedPath, targetValue) : targetValue(proxifier.tree, nestedPath);

            if (dynamicValue && dynamicValue[IS_PROXY]) {
              return proxifier.proxify(dynamicValue[VALUE], dynamicValue[PATH]);
            }

            return dynamicValue;
          }

          if (targetValue === undefined) {
            return undefined;
          }

          return proxifier.proxify(targetValue, nestedPath);
        },
        set: function set(target, prop, value) {
          var nestedPath = proxifier.concat(path, prop);
          proxifier.ensureMutationTrackingIsEnabled(nestedPath);
          proxifier.ensureValueDosntExistInStateTreeElsewhere(value);

          if (isPlainObject(target[prop]) || Array.isArray(target[prop])) {
            proxifier.tree.master.removeProxy(nestedPath);
          }

          var objectChangePath;

          if (!(prop in target)) {
            objectChangePath = path;
          }

          var mutationTree = proxifier.getMutationTree();
          mutationTree.addMutation({
            method: 'set',
            path: nestedPath,
            args: [value]
          }, objectChangePath);

          if (typeof value === 'function') {
            return Reflect.set(target, prop, function () {
              return value;
            });
          }

          return Reflect.set(target, prop, value);
        },
        deleteProperty: function deleteProperty(target, prop) {
          var nestedPath = proxifier.concat(path, prop);
          proxifier.ensureMutationTrackingIsEnabled(nestedPath);

          if (isPlainObject(target[prop]) || Array.isArray(target[prop])) {
            proxifier.tree.master.removeProxy(nestedPath);
          }

          var objectChangePath;

          if (prop in target) {
            objectChangePath = path;
          }

          var mutationTree = proxifier.getMutationTree();
          mutationTree.addMutation({
            method: 'unset',
            path: nestedPath,
            args: []
          }, objectChangePath);
          delete target[prop];
          return true;
        }
      }));
    }
  }, {
    key: "proxify",
    value: function proxify(value, path) {
      if (value) {
        if (value[IS_PROXY] && String(value[PATH]) !== String(path)) {
          return this.proxify(value[VALUE], path);
        } else if (value[IS_PROXY]) {
          return value;
        } else if (isPlainObject(value)) {
          return this.createObjectProxy(value, path);
        } else if (Array.isArray(value)) {
          return this.createArrayProxy(value, path);
        }
      }

      return value;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.proxyCache = {};
      this.disposeRemoveProxy();
    }
  }]);

  return Proxifier;
}();